import React, {useState, useEffect, useRef} from 'react';
import './Match.css';
import {listClubProam, listClubProad, listClubProbd, listClubProbm} from '../variables';
import Partie from './Partie';
import { 
    BsFillCaretRightFill 
} from "react-icons/bs";
import axios from 'axios';
import LogoClub from './LogoClub';
import AnimateHeight from 'react-animate-height';
import io from 'socket.io-client';
import CartridgePlayers from './CartridgePlayers';

var XMLParser = require('react-xml-parser');

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

const Match = ({championnat, match, headerLivescore, currentDay, deploy, currentClub = null, showTour = false}) => {
    const [socket, setSocket] = useState(null);
    const [clubOne, setClubOne] = useState('');
    const [clubTwo, setClubTwo] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [details, setDetails] = useState([]);

    const [livescore, setLivescore] = useState([]);
    const [jsonMatch, setJsonMatch] = useState(null);

    const livescoreRef = useRef(livescore);
    const jsonMatchRef = useRef(jsonMatch);

    const [liveTeamA, setLiveTeamA] = useState([]);
    const [liveTeamX, setLiveTeamX] = useState([]);

    useEffect(() => {
        // On initialise nos paramètres
        setClubOne(getClubOne());
        setClubTwo(getClubTwo());
        // si on arrive depuis l'acceuil
        // alors on déploie le match sélectionné
        if (deploy === getRencID()) {
            if (headerLivescore.status == "en_cours") {
                setShowDetails(true);
            }
            else {
                getDetailsMatch();
            }
        }
    }, []);
    
    useEffect(() => {
        // const today = new Date().toLocaleDateString("fr-FR");

        // on ne veut pas que la connexion socket soit établit si le match est fermé
        if (!showDetails) {
            // si livescoring
            if (headerLivescore.status == 'en_cours' && socket !== null) {
                // on désactive le socket si on n'a pas déroulé le match
                socket.disconnect();
                setSocket(null);
                return;
            }
        }


        // on initialise le socket pour les matchs déroulés d'aujourd'hui 
        if (headerLivescore.status == 'en_cours') {
            const link = "https://fftt.dafunker.com:3000/livescore_" + getRencID() + "?" + getCData().replaceAll(',', '&');
            const tmpSocket = io(link);

            // Message de connexion
            tmpSocket.on('connect', () => {
            });
    

            // Ecouter les messages d'update de l'entete du match
            tmpSocket.on('update', (jsonSocket) => {
                parseLivescoreForPartie(jsonSocket);
                jsonMatchRef.current = jsonSocket;
                setJsonMatch(jsonSocket);
            });

            // Ecouter les messages d'update du match
            tmpSocket.on('update_partie', (jsonPartie) => {
                mergeJsonPartieWithLivescore(jsonPartie);
            });

    
            // on sauvegarde le socket
            setSocket(tmpSocket);
    
            // Nettoyage de l'effet lors du démontage du composant
            return () => {
                tmpSocket.disconnect();
            };
        }

    }, [showDetails]);

    const getDetailsMatch = async () => {
        const link = "https://apiv2.fftt.com/mobile/pxml/xml_chp_renc.php?id=SW001&tm=20210925115025407&tmc=b69782b1b8e550626506d025fe4824b7db6859b7&renc_id=" + getRencID();
        axios
        .get(link, {
            "Content-Type": "application/xml; charset=utf-8"
        })
        .then(function(res) {
            let data = new XMLParser().parseFromString(res.data).children;
            // on vérifie que le match ait bien des parties jouées
            const partie = data.find(item => item.name === "partie");
            const joueur = data.find(item => item.name === "joueur");
            if ((partie !== null && partie !== undefined) || (joueur !== null && joueur !== undefined)) {
                if (partie.children.length > 0 || joueur.children.length > 0) {
                    setDetails(parseXMLtoJSON(data));
                    setShowDetails(!showDetails);
                    return;
                }
            }
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    const getDetailsDafunker = async () => {
        const link = "https://fftt.dafunker.com/livescore/get/" + getRencID();
        axios
        .get(link, {
            "Content-Type": "application/xml; charset=utf-8"
        })
        .then(function(res) {
            let data = res.data;
            parseLivescoreForPartie(data);
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    const handleShowDetails = (e, responsive = false) => {
        e.preventDefault();

        if(headerLivescore.status === "bientot")
        {
            return false;
        }

        if (responsive) {
            if (getWindowSize().innerWidth > 1000) {
                return false;
            }
        }

        if (showDetails) {
            setShowDetails(false);
            return;
        }

        if (headerLivescore.status === "en_cours") {
            // rien
        } 
        else if (details.length == 0) {
            getDetailsMatch();
            // RAJOUTER UNE CONDITION POUR SAVOIR SI IL Y A DES DETAILS
            // SI CEST LE CAS ALORS ON NE RECUPERE PAS LES MATCHS DU LIVESCORING
            if (headerLivescore.status === "termine") {
                getDetailsDafunker();
                setShowDetails(!showDetails);
            }
            return;
        }

        setShowDetails(!showDetails);
    }

    const parseXMLtoJSON = (xmlMatch) => {
        const parties = [];
        const teamA = [];
        const teamX = [];
        xmlMatch.forEach((item) => {
            if (item.name === 'partie') {
                let object = {};
                item.children.forEach((child) => {
                    // on adapte le score pour correspondre au format livescore
                    // 09 -05 07 -09 06 ->>>> [[11, 9], [5, 11], [11, 7], [9, 11], [11, 6]]
                    if (child.name === "detail") {
                        // notre array qui contient le score
                        const sets = [];
                        // on split le string pour récupérer chaque set
                        const scores = child.value.split(' ');
                        // on insère chaque set dans un array pour correspondre au bon format
                        scores.forEach((score) => {
                            const scoreBrut = parseInt(score.replace('-', ''));
                            let scoreJA = 0; let scoreJB = 0;

                            // défaite du joueur A
                            if (score.includes('-')) {
                                scoreJA = parseInt(scoreBrut);
                                scoreJB = parseInt(scoreBrut >= 10 ? scoreBrut + 2 : 11);
                            }
                            // victoire du joueur A
                            else {
                                scoreJA = parseInt(scoreBrut >= 10 ? scoreBrut + 2 : 11);
                                scoreJB = parseInt(scoreBrut);
                            }

                            // à noter que le parseInt retire le 0 devant le score
                            // utile pour récupérer le score directement 

                            // on insère les scores dans notre array
                            sets.push([scoreJA, scoreJB]);
                        });
                        object[child.name] = sets;
                    }
                    else {
                        object[child.name] = child.value;
                    }
                })
                // on insère la partie
                if(Object.keys(object).length > 0)
                {
                    parties.push(object);
                }
            }
            else if(item.name === 'joueur')
            {
                if(item.children[0].value.length > 0 && item.children[1].value.length > 0)
                {
                    teamA.push(item.children[0].value + " " + item.children[1].value);
                }
                if(item.children[2].value.length > 0 && item.children[3].value.length > 0)
                {
                    teamX.push(item.children[2].value + " " + item.children[3].value);
                }
            }
        })
        if(teamA.length > 0)
        {
            setLiveTeamA(teamA);
        }
        if(teamX.length > 0)
        {
            setLiveTeamX(teamX);
        }
        return parties;
    }

    const CalSetA = (score) =>  {
        let total = 0;
        score.forEach((game) => {
           
            if(game[0] > game[1])
            {
                total = total + 1;
            }
        })
        return total;
    }

    const CalSetX = (score) =>  {
        let total = 0;
        score.forEach((game) => {
           
            if(game[0] < game[1])
            {
                total = total + 1;
            }
        })
        return total;
    }

    const parseLivescoreForPartie = (match) => {
        const parties = [];
        match.parties.forEach((partie) => {

             // on récupère le slotID des joueurs
            const slotIdJA = partie.joueur1.slotId;
            const slotIdJB = partie.joueur2.slotId;
            let fullNameJA = ""; let fullNameJB = "";

            if (slotIdJA !== "") {
                fullNameJA = match.equipe1.joueurs[slotIdJA].nom + " " + match.equipe1.joueurs[slotIdJA].prenom;
            }

            if (slotIdJB !== "") {
                fullNameJB = match.equipe2.joueurs[slotIdJB].nom + " " + match.equipe2.joueurs[slotIdJB].prenom;
            }
 
            parties.push({
                "id": partie.id,
                "ja": fullNameJA,
                "jb": fullNameJB,
                "scorea": '' + CalSetA(partie.score),
                "scoreb": '' + CalSetX(partie.score),
                "teamA" : match.equipe1?.score,
                "teamX" : match.equipe2?.score,
                "detail": partie.score,
                "premier_serveur": partie.premier_serveur,
            });
        })
        livescoreRef.current = parties;
        setLivescore(parties);

        const joueursA = [];
        joueursA.push(match?.equipe1?.joueurs?.JA1);
        joueursA.push(match?.equipe1?.joueurs?.JA2);
        joueursA.push(match?.equipe1?.joueurs?.JA3);
        joueursA.push(match?.equipe1?.joueurs?.JA4);
        setLiveTeamA(joueursA);

        const joueursX = [];
        joueursX.push(match?.equipe2.joueurs?.JB1);
        joueursX.push(match?.equipe2.joueurs?.JB2);
        joueursX.push(match?.equipe2.joueurs?.JB3);
        joueursX.push(match?.equipe2.joueurs?.JB4);
        setLiveTeamX(joueursX);
    }

    const mergeJsonPartieWithLivescore = (partieToMerge) => {
        let livescorePartie = livescoreRef.current.findIndex(partie => partie.id === partieToMerge.id);
        let tmpLivescore = [...livescoreRef.current];
        // on regarde si le match a été supprimé
        if (partieToMerge.status === "deleted") {
            // si on avait le match alors on supprime
            if (livescorePartie !== -1) {
                tmpLivescore = tmpLivescore.filter(partie => partie.id !== partieToMerge.id);
                livescoreRef.current = tmpLivescore;
                setLivescore(tmpLivescore)
            }
            return;
        }

        // on récupère le slotID des joueurs
        const slotIdJA = partieToMerge.joueur1.slotId;
        const slotIdJB = partieToMerge.joueur2.slotId;
        let fullNameJA = ""; let fullNameJB = "";

        if (slotIdJA !== "") {
            fullNameJA = jsonMatchRef.current.equipe1.joueurs[slotIdJA].nom + " " + jsonMatchRef.current.equipe1.joueurs[slotIdJA].prenom;
        }

        if (slotIdJB !== "") {
            fullNameJB = jsonMatchRef.current.equipe2.joueurs[slotIdJB].nom + " " + jsonMatchRef.current.equipe2.joueurs[slotIdJB].prenom;
        }
        
        const data = {
            "id": partieToMerge.id,
            "ja": fullNameJA,
            "jb": fullNameJB,
            "scorea": '' + CalSetA(partieToMerge.score),
            "scoreb": '' + CalSetX(partieToMerge.score),
            "teamA" : '0',
            "teamX" : '0',
            "detail": partieToMerge.score,
            "premier_serveur": partieToMerge.premier_serveur,
        };

        // on update/insert
        if (livescorePartie !== -1) {
            tmpLivescore[livescorePartie] = data
        }
        else {
            tmpLivescore.push(data);
        }
        

        // on met à jour les matchs
        livescoreRef.current = tmpLivescore;
        setLivescore(tmpLivescore)
    }

    const getCData = () => {
        if (match == null) return null;
        return match.getElementsByTagName('lien')[0].value;
    }

    const getRencID = () => {
        const cData = match.getElementsByTagName('lien')[0].value;
        const rencID = cData.split('renc_id=')[1].split('&')[0];
        return rencID;
    }

    const getCorrectListClub = (value) => {
        switch (value) {
            case 'proam':
                return listClubProam;
            case 'probm':
                return listClubProbm;
            case 'proad':
                return listClubProad;
            case 'probd':
                return listClubProbd;
            default:
                break;
        }
    }

    const getClubOne = () => {
        const team = match.getElementsByTagName('equa')[0].value;
        const cData = match.getElementsByTagName('lien')[0].value;
        const num = cData.split('clubnum_1=')[1].split('&')[0];
        return getCorrectListClub(championnat).find(item => item.identifier.trim() == num)  || getCorrectListClub(championnat).find(item => item.title == team);
    }

    const getClubTwo = () => {
        const team = match.getElementsByTagName('equb')[0].value;
        const cData = match.getElementsByTagName('lien')[0].value;
        const num = cData.split('clubnum_2=')[1].split(' ')[0];
        return getCorrectListClub(championnat).find(item => item.identifier.trim() == num) || getCorrectListClub(championnat).find(item => item.title == team);
    }

    const getDateMatch = () => {
        const value = match.getElementsByTagName('datereelle')[0].value
        const date = new Date(value.split('/')[2] + '-' + value.split('/')[1] + '-' + value.split('/')[0]);
        const day = date.getDate();
        let month = date.toLocaleString('default', { month: 'long' });

        if (month.length > 3) {
            month = month.substring(0, 3) + '.';
        }

        return day + " " + month;
    }

    const getTimeMatch = () => {
        return match.getElementsByTagName('heurereelle')[0]?.value || '';
    }


    const getScoreA = () => {
        if (headerLivescore.status === 'en_cours') {
            if (livescore.length > 0) {
                return parseInt(livescore[0].teamA);
            }
            else {
                return parseInt(headerLivescore.score.split('-')[0]);
            }
        }
        else if (headerLivescore.status === "termine") {
            return parseInt(headerLivescore.score.split('-')[0]);
        }
        else {
            return parseInt(match.getElementsByTagName('scorea')[0].value);
        }
    }

    const getScoreX = () => {
        if (headerLivescore.status === 'en_cours') {
            if (livescore.length > 0) {
                return parseInt(livescore[0].teamX);
            }
            else {
                return parseInt(headerLivescore.score.split('-')[1]);
            }
        }
        else if (headerLivescore.status === "termine") {
            return parseInt(headerLivescore.score.split('-')[1]);
        }
        else {
            return parseInt(match.getElementsByTagName('scoreb')[0].value);
        }
    }

    const getIdentifierClub = (index) => {
        if (match) {
            const cData = match.getElementsByTagName('lien')[0].value.trim();
            if (index === 1) {
                return cData.split('clubnum_1=')[1].split('&')[0];
            }
            if (index === 2) {
                return cData.split('clubnum_2=')[1].split(' ')[0];
            }
    
        }
        return null;
    }

    const currentClubIsWinner = () => {
        const equa = match.getElementsByTagName('equa')[0].value.trim();
        const equb = match.getElementsByTagName('equb')[0].value.trim();
        const identifier = currentClub.identifier
        if (equa === currentClub.title.trim() || identifier === getIdentifierClub(1)) {
            return parseInt(getScoreA()) > parseInt(getScoreX());
        }
        else if (equb === currentClub.title.trim() || identifier === getIdentifierClub(2)) {
            return parseInt(getScoreX()) > parseInt(getScoreA());
        }
        return false;
    }

    const getStatus = () => {
        const today = new Date().toLocaleDateString("fr-FR");

        switch (headerLivescore.status) {
            case "bientot":
                if (match.getElementsByTagName('datereelle')[0].value === today) {
                    return "bientot";
                }
                return "";
            default:
                return headerLivescore.status;
        }
    }

    const getStatusMatch = () => {
        return (getStatus() == "termine" && match?.winner) ? "termine_live" : getStatus();
    }

    const isTerminate = () => {
        return headerLivescore.status === "termine" && details.length < 1;
    }

    const getColorMatch = () => {
        if (currentClub !== null && headerLivescore.status !== "en_cours") {
            let color = "rgb(180, 180, 180)";
            if (getScoreA() >= 0 && getScoreX() >= 0) {
                color = currentClubIsWinner() ? 'green' : 'red'
            }
            return {borderRight: `12px solid ${color}`, borderRightStyle: 'inset'}
        }
        return {};
    }

    return ( 
        <div className="match_all_component">
            <div 
                className={"match_component " + getStatusMatch()} 
                style={getColorMatch()}
                onClick={(e)=>handleShowDetails(e)} >
                <div className="match_informations">

                    {
                        currentDay > 0 &&
                        <span className="match_current_day">J{currentDay}</span>
                    }

                    {/* Left center side */}
                    <div className="match_left_side">
                        <span className="match_team_name" style={{fontWeight: getScoreA() > getScoreX() ? 'bold' : 'none'}}>{clubOne !== undefined && clubOne.title}</span>
                        {
                            (clubOne !== undefined && clubOne.logo !== '') &&
                            <LogoClub club={clubOne} width='64' height='64' activateLink={false} />
                        }
                    </div>
                    {/* Afficha du score ou de la date selon l'état du match */}
                    <div className={`informations_center ${(getScoreA() >= 0 && getScoreX() >= 0) ? "scores" : "" }`}>
                        {            
                            (getScoreA() >= 0 && getScoreX() >= 0) && (
                                <>
                                    <span className="score_container" style={{minWidth: 30, maxWidth: 30, whiteSpace: 'nowrap'}}>
                                        <span className="match_score top" style={{fontWeight: getScoreA() > getScoreX() ? 'bold' : 'normal'}}>{getScoreA()}</span>
                                        <span className="match_score middle"> - </span>
                                        <span className="match_score bottom" style={{fontWeight: getScoreA() < getScoreX() ? 'bold' : 'normal'}}>{getScoreX()}</span>
                                    </span>
                                    {(headerLivescore.status == "en_cours" ) && (
                                        <div className='playoffdown_date'>
                                            En&nbsp;cours
                                        </div>
                                    )}
                                </>
                            )
                            || headerLivescore.status !== "en_cours" && (
                                <span className="date_container" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 75, maxWidth: 75}}>
                                    <span className="match_date"> {getDateMatch()}</span>
                                    <span className="match_time">{getTimeMatch()}</span>
                                    {showTour && headerLivescore.tour && <span className="match_tour">{"journée n°" + (headerLivescore.tour || "")}</span>}
                                </span>
                            )
                        }
                    </div>
                    

                    {/* Right center side */}
                    <div className="match_right_side">
                        {
                            (clubTwo !== undefined && clubTwo.logo !== '') &&
                            <LogoClub club={clubTwo} width='64' height='64' activateLink={false} />
                        }
                        <span className="match_team_name" style={{fontWeight: getScoreA() < getScoreX() ? 'bold' : 'normal'}}>{clubTwo !== undefined && clubTwo.title}</span>
                    </div>
                </div>
                
                {/* On affiche la flèche de défilement pour obtenir la feuille de match officiel
                si le match est terminé */}
                {
                    headerLivescore.status !== "en_cours" && getScoreA() >= 0 && getScoreX() >= 0
                    &&
                    <BsFillCaretRightFill className={showDetails ? "match_arrow active" : "match_arrow"} size={38} onClick={(e)=>handleShowDetails(e)}/>
                }

                {/* Si le match est en train d'être livescorer alors on affiche le record */}
                {
                    (getStatus() === "en_cours") && getWindowSize().innerWidth > 1000 &&
                    <BsFillCaretRightFill color='red' className={showDetails ? "match_arrow active" : "match_arrow"} size={38} onClick={(e)=>handleShowDetails(e)} />
                }
                {
                    (getStatus() == "bientot") && getWindowSize().innerWidth > 1000 &&
                    <span  
                        style={{
                            backgroundColor: "var(--yellow-color)",
                            top: "50%",
                            borderRadius: 5,
                            padding: "5px 10px",
                            transform: "translateY(-50%)",  
                            right: 10, 
                            position: 'absolute',
                            fontSize: 18,
                            transition: '0.2s ease-in-out all',
                        }}
                    >Aujourd'hui</span>
                    }
            </div>
            {
                <AnimateHeight 
                    key={getRencID()} 
                    id={getRencID()}
                    duration={500}
                    height={showDetails ? 'auto' : 0}
                >
                    <div className="details_component">
                        <h2 style={{fontSize: 20, fontWeight: 400, color: 'rgba(50,50,50,0.7)', borderBottom: '2px solid white', textAlign: 'center', maxWidth: 300}}>
                            {/* Détails de la rencontre */}
                            {
                                 (headerLivescore.status === "en_cours" || isTerminate()) &&
                                 livescore.length + " "
                                 ||
                                 details.length + " "
                            }
                            partie(s) disputé(es)
                        </h2>
                        {/* Affichage du cartouche des joueurs */                        
                        (headerLivescore.status === "en_cours" || isTerminate()) &&
                            <CartridgePlayers id={getRencID()} liveTeamA={liveTeamA} liveTeamX={liveTeamX} isFromSPID={false}></CartridgePlayers>  
                        ||
                            <CartridgePlayers id={getRencID()} liveTeamA={liveTeamA} liveTeamX={liveTeamX} isFromSPID={true}></CartridgePlayers>  
                        }
                        {/* Affichage du détail des matchs */}
                        <div style={{maxWidth: getWindowSize().innerWidth > 1000 ? 500 : 300}}>
                            {
                                    (headerLivescore.status === "en_cours" || isTerminate()) &&
                                    livescore?.map((detail, index) => {
                                        return (
                                            <div
                                                key={index} 
                                                style={{marginBottom: 20}}>
                                                <Partie status={headerLivescore.status} match={detail} teamJA={getClubOne()} teamJB={getClubTwo()} isLivescoring />
                                            </div>
                                        )
                                    })
                                    ||
                                    details?.map((detail, index) => {
                                        return (
                                            <div
                                                key={index} 
                                                style={{marginBottom: 20}}>
                                                <Partie status={headerLivescore.status} match={detail} teamJA={getClubOne()} teamJB={getClubTwo()} isOffDown/>
                                            </div>
                                        )
                                    })
                            }
                        </div>
                    </div>
                </AnimateHeight>
            }
            
        </div>
        
    );
}

export default Match;